import { render, staticRenderFns } from "./IntercomFrame.vue?vue&type=template&id=592a5ece&scoped=true&"
import script from "./IntercomFrame.vue?vue&type=script&lang=ts&"
export * from "./IntercomFrame.vue?vue&type=script&lang=ts&"
import style0 from "./IntercomFrame.vue?vue&type=style&index=0&id=592a5ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592a5ece",
  null
  
)

export default component.exports